const FacebookDestinationType =
{
	TIMELINE: 'TIMELINE',
	PAGE: 'PAGE',
	GROUP: 'GROUP',
	EVENT: 'EVENT',
	TEST: 'TEST'
}
export default FacebookDestinationType;
